module.exports = __webpack_public_path__ + "static/media/Registeel_gaussian2.be7471a2.png";